import { EndpointMixins } from "./endpoint-mixins/index.js";

export class Endpoint extends EndpointMixins {}
